
import LoginAdmin from './loginAdmin'
import Dashboard  from './dashboard'
import Parceiros from './parceiros'
import Servicos from './servicos'
import Motoristas from './motoristas'
import Indicacoes from './indicacoes'
import Usuarios from './usuarios'

export default {
    LoginAdmin, 
    Dashboard, 
    Motoristas, 
    Indicacoes, 
    ...Parceiros, 
    ...Servicos, 
    ...Usuarios, 

}
